import { render, staticRenderFns } from "./FakeWizardTabs.vue?vue&type=template&id=128d50cd&"
import script from "./FakeWizardTabs.vue?vue&type=script&lang=ts&"
export * from "./FakeWizardTabs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports